module.exports = __webpack_public_path__ + "static/media/pupupBrocastTop.27d9e42a.png";